export type KnowledgeRoute =
  | { readonly name: "home" }
  | { readonly name: "documents" }
  | {
      readonly name: "document";
      readonly itemId: string;
      readonly blockId?: string;
    }
  | { readonly name: "canvases" }
  | { readonly name: "canvas"; readonly itemId: string }
  | { readonly name: "recent" }
  | { readonly name: "favorites" }
  | { readonly name: "trash" }
  | { readonly name: "folder"; readonly folderId: string }
  | { readonly name: "tag"; readonly tagId: string }
  | { readonly name: "organization" }
  | { readonly name: "search"; readonly query: string }
  | { readonly name: "settings" };

export function parseKnowledgeRoute(hash: string): KnowledgeRoute {
  const raw = hash.replace(/^#\/?/u, "");
  const [pathname = "", queryString = ""] = raw.split("?", 2);
  const segments = pathname.split("/").filter(Boolean);
  if (segments[0] === "documents" && segments[1]) {
    const blockId = new URLSearchParams(queryString).get("block");
    return {
      name: "document",
      itemId: decodeURIComponent(segments[1]),
      ...(blockId ? { blockId } : {}),
    };
  }
  if (segments[0] === "documents") return { name: "documents" };
  if (segments[0] === "canvases" && segments[1]) {
    return { name: "canvas", itemId: decodeURIComponent(segments[1]) };
  }
  if (segments[0] === "canvases") return { name: "canvases" };
  if (segments[0] === "recent") return { name: "recent" };
  if (segments[0] === "favorites") return { name: "favorites" };
  if (segments[0] === "trash") return { name: "trash" };
  if (segments[0] === "folders" && segments[1]) {
    return { name: "folder", folderId: decodeURIComponent(segments[1]) };
  }
  if (segments[0] === "tags" && segments[1]) {
    return { name: "tag", tagId: decodeURIComponent(segments[1]) };
  }
  if (segments[0] === "organization") return { name: "organization" };
  if (segments[0] === "search") {
    return {
      name: "search",
      query: new URLSearchParams(queryString).get("q") ?? "",
    };
  }
  if (segments[0] === "settings") return { name: "settings" };
  return { name: "home" };
}

export function formatKnowledgeRoute(route: KnowledgeRoute): string {
  switch (route.name) {
    case "home":
      return "#/";
    case "documents":
      return "#/documents";
    case "document":
      return `#/documents/${encodeURIComponent(route.itemId)}${
        route.blockId ? `?block=${encodeURIComponent(route.blockId)}` : ""
      }`;
    case "canvases":
      return "#/canvases";
    case "canvas":
      return `#/canvases/${encodeURIComponent(route.itemId)}`;
    case "recent":
      return "#/recent";
    case "favorites":
      return "#/favorites";
    case "trash":
      return "#/trash";
    case "folder":
      return `#/folders/${encodeURIComponent(route.folderId)}`;
    case "tag":
      return `#/tags/${encodeURIComponent(route.tagId)}`;
    case "organization":
      return "#/organization";
    case "search":
      return `#/search?q=${encodeURIComponent(route.query)}`;
    case "settings":
      return "#/settings";
  }
}
